const convertZwaveChangedDescription = (description: string): string => (description === 'changes state' ? 'any changes' : description)

export default convertZwaveChangedDescription
